import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function heading(): ComponentStyle {
  return {
    componentName: 'heading',
    baseStyle: {
      letterSpacing: '0.03rem',
      lineHeight: 'normal'
    },
    variants: {}
  };
}
